import React from 'react';
import { connect } from 'react-redux';
import { updateOrganization, deleteOrganization, leaveOrganization } from "../../../../Redux/Actions/EndUser/OrganizationAction";
import { selectedOrganization } from '../../../../Redux/Actions/EndUser/AccountDetailsActions';
import { withRouter } from 'react-router';
import { userService, auth } from '../../../../services';
import { Input } from 'reactstrap';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import './OrganizationsPage.scss';
import { history } from '../../../../helpers/history';
import { fetchStates } from '../../../../Redux/Actions/CommonActions';
import SpanSpinner from '../../../Shared/SpanSpinner/SpanSpinner';
import OrganizationUsers from './OrganizationUsers';
import { Alert } from 'reactstrap';

class OrganizationsPage extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			organizationInEdit: {
				address1: '',
				address2: '',
				city: '',
				organizationId: 0,
				organizationName: '',
				phone: null,
				state: {
					id: 0,
					name: ''
				},
				userCanManageOrganization: true,
				userId: '',
				zip: '',
			},
			touched: {
				address1: false,
				address2: false,
				city: false,
				organizationName: false,
				state: false,
				zip: false,
			},
			organizationSaved: {},
			isActive: false,
			isNewOrganization: true,
			isUpdating: false,
            isLeaving: false,
			userCanManageOrganization: false
		};

		if (!auth.isAuthenticated()) {
			this.props.history.push('/');
		}

		this.onDialogInputChange = this.onDialogInputChange.bind(this);
	}

	componentDidMount() {
		this.props.fetchStates();
		this.setUserId();

		if (this.props.selectedOrganizationObj) {
			this.setState({
				isNewOrganization: false,
				userCanManageOrganization: this.props.selectedOrganizationObj.userCanManageOrganization
			})
			this.setupOrganizationInEdit(this.props.selectedOrganizationObj);
		}
	}

	componentDidUpdate() {
        if ((this.props.updating === false && this.state.isUpdating === true)
         || ( this.props.leaving === false && this.state.isLeaving === true)) {
			// Reset - show Organization Details after creating a new Organization
			this.reset();
		}
	}

	reset() {
		this.props.selectedOrganization(this.props.newOrganization);
		this.setState({
			isActive: false,
			isNewOrganization: false,
			userCanManageOrganization: true,
			isUpdating: false,
            isLeaving: false
		});
	}

	setUserId() {
		if (this.props.organization.userId) {
			const edited = this.state.organizationInEdit;
			edited.userId = this.props.organization.userId;
			this.setState({
				organizationInEdit: edited
			})
		} else if (!this.props.selectedOrganizationObj) {
				window.location = '/dashboard';
		}
	}

	setupOrganizationInEdit(dataItem) {
		const clone = Object.assign({}, dataItem)

		for (let [key, value] of Object.entries(clone)) {
			if (value !== null) {
				this.state.organizationInEdit[key] = value;
			}
		}
	}

	handleBlur = (field) => (evt) => {
		this.setState({
			touched: { ...this.state.touched, [field]: true },
		});
	}

	handleState = (event) => {
		let target = event.target;
		const value = target.type === 'checkbox' ? target.checked : target.value;
		const name = target.props ? target.props.name : target.name;

		const edited = this.state.organizationInEdit;
		edited.state.name = event.target.value.name;
		edited.state.id = event.target.value.id;

		this.setState({
			organizationInEdit: edited,
			isActive: true
		});
	};

	handleZipChange = (event) => {
		var originalValue = this.state.organizationInEdit.zip;
		const edited = this.state.organizationInEdit;
		var value = event.target.value.replace(/\D/g, '');;
		if ((value.match(/^[0-99999]|^$/) || value == "") && value.length <= 5) {
			edited.zip = value;
			this.setState({
				organizationInEdit: edited,
				isActive: true
			});
		}
		else {
			edited.zip = originalValue;
			this.setState({
				organizationInEdit: edited,
				isActive: true
			});
		}
	}

	onDialogInputChange(event) {
		let target = event.target;
		const value = target.type === 'checkbox' ? target.checked : target.value;
		const name = target.props ? target.props.name : target.name;

		const edited = this.state.organizationInEdit;
		edited[name] = value;
		this.setState({
			organizationInEdit: edited,
			isActive: true
		});
	}

    handleSubmit = (event) => {
		event.preventDefault();
		if (this.isModelValid()) {
			const organizationPost = Object.assign({}, this.state.organizationInEdit);
			for (let [key, value] of Object.entries(organizationPost)) {
				if (value === '') {
					organizationPost[key] = null;
				}
			}

			this.props.updateOrganization(organizationPost);
			this.setState({
				isUpdating: true,
				organizationSaved: organizationPost
			})
		} else {
			this.setAllTouchedTrue();
		}
	}

    handleLeaving = (event) => {
		event.preventDefault();

		const organizationPost = Object.assign({}, this.state.organizationInEdit);
		for (let [key, value] of Object.entries(organizationPost)) {
			if (value === '') {
				organizationPost[key] = null;
			}
		}

		this.props.leaveOrganization(organizationPost);
		this.setState({
            isLeaving: true,
			organizationSaved: organizationPost
		})
	}

	handleDelete = () => {
		this.props.deleteOrganization(this.props.selectedOrganizationObj);
	}

	isModelValid() {
		return this.state.organizationInEdit.address1 !== "" &&
		this.state.organizationInEdit.city !== "" &&
		this.state.organizationInEdit.organizationName !== "" &&
		this.state.organizationInEdit.state.id !== 0 &&
		this.state.organizationInEdit.state.name !== "" &&
		this.state.organizationInEdit.zip !== "";
	}

	setAllTouchedTrue() {
		this.setState({
			touched: {
				address1: true,
				address2: true,
				city: true,
				organizationName: true,
				state: true,
				zip: true,
			},
		})
	}

	render() {
		return (
			<div className="organization-container">
				{/*<Alert
					color={this.props.organization.alertType}
					isOpen={typeof (this.props.organization.alertVisible) !== "undefined" && this.props.organization.alertVisible}
					style={{ position: 'fixed', width: '100%' }}
				>
					{this.props.organization.alertMessage}
				</Alert>*/}
				{this.props.common.visible ? (
					<Alert
						color={this.props.common.color}
						isOpen={this.props.common.visible}
						style={{ position: 'fixed', width: '100%' }}
					>
						{this.props.common.message}
					</Alert>
				) : null}
				<h1 className="organization-title pt-3 pb-3">{this.state.isNewOrganization ? 'New Organization' : 'Organization Details'}</h1>
				<div className="organization-body organization-form-wrapper">
					<div className="col-lg-4 col-sm-12">
						{/* <h1 className="organization-title pt-3 pb-3">{this.state.isNewOrganization ? 'New Organization' : 'Organization Details'}</h1> */}
						<div>
							<div className="organization-col">

								<form className="organization-form" onSubmit={this.handleSubmit}>
									<div className="form-group">
										<div className="col-sm-4">
											<label htmlFor="organizationName"
												className={this.state.touched.organizationName && this.state.organizationInEdit.organizationName === '' ? "error" : ""}
											>Organization Name:</label>
										</div>
										<div className="col-sm-8">
											<Input
												type="text"
												name="organizationName"
												id="organizationName"
												value={this.state.organizationInEdit.organizationName}
												onChange={this.onDialogInputChange}
												invalid={this.state.touched.organizationName && this.state.organizationInEdit.organizationName === '' ? true : false}
												onBlur={this.handleBlur('organizationName')}
												disabled={this.state.isNewOrganization || this.state.userCanManageOrganization ? false : true}
											/>
										</div>
									</div>
									<div className="form-group">
										<div className="col-sm-4">
											<label htmlFor="address1"
												className={this.state.touched.address1 && this.state.organizationInEdit.address1 === '' ? "error" : ""}
											>Address 1:</label>
										</div>
										<div className="col-sm-8">
											<Input
												type="text"
												name="address1"
												id="address1"
												value={this.state.organizationInEdit.address1}
												onChange={this.onDialogInputChange}
												invalid={this.state.touched.address1 && this.state.organizationInEdit.address1 === '' ? true : false}
												onBlur={this.handleBlur('address1')}
												disabled={this.state.isNewOrganization || this.state.userCanManageOrganization ? false : true}
											/>
										</div>
									</div>
									<div className="form-group">
										<div className="col-sm-4">
											<label htmlFor="address2">Address 2:</label>
										</div>
										<div className="col-sm-8">
											<Input
												type="text"
												name="address2"
												id="address2"
												value={this.state.organizationInEdit.address2}
												onChange={this.onDialogInputChange}
												disabled={this.state.isNewOrganization || this.state.userCanManageOrganization ? false : true}
											/>
										</div>
									</div>
									<div className="form-group">
										<div className="col-sm-4">
											<label htmlFor="city"
												className={this.state.touched.city && this.state.organizationInEdit.city === '' ? "error" : ""}
											>City:</label>
										</div>
										<div className="col-sm-8">
											<Input
												type="text"
												name="city"
												id="city"
												value={this.state.organizationInEdit.city}
												onChange={this.onDialogInputChange}
												invalid={this.state.touched.city && this.state.organizationInEdit.city === '' ? true : false}
												onBlur={this.handleBlur('city')}
												disabled={this.state.isNewOrganization || this.state.userCanManageOrganization ? false : true}
											/>
										</div>
									</div>
									<div className="form-group">
										<div className="col-sm-4">
											<label htmlFor="state"
												className={this.state.touched.state && this.state.organizationInEdit.state.name === '' ? "error" : ""}
											>State:</label>
										</div>
										<div className="col-sm-8">
											<DropDownList data={this.props.common.states}
												id="state"
												name="state"
												textField="name"
												dataItemKey="id"
												onChange={this.handleState}
												value={this.state.organizationInEdit.state}
												className={
													`${this.state.touched.state && this.state.organizationInEdit.state.name === '' ? "error" : ""} ${this.state.isNewOrganization || this.state.userCanManageOrganization ? '' : 'disabled'}`
												}
												onBlur={this.handleBlur('state')}
												disabled={this.state.isNewOrganization || this.state.userCanManageOrganization ? false : true}
											/>
										</div>
									</div>
									<div className="form-group">
										<div className="col-sm-4">
											<label htmlFor="zip"
												className={this.state.touched.zip && this.state.organizationInEdit.state.zip === '' ? "error" : ""}
											>Zip:</label>
										</div>
										<div className="col-sm-8">
											<Input
												type="text"
												name="zip"
												id="zip"
												pattern="(\d{5}([\-]\d{4})?)"
												placeholder="12345"
												title="Zip Code (Format: 12345)"
												value={this.state.organizationInEdit.zip}
												onChange={this.handleZipChange}
												invalid={this.state.touched.zip && this.state.organizationInEdit.zip === '' ? true : false}
												onBlur={this.handleBlur('zip')}
												disabled={this.state.isNewOrganization || this.state.userCanManageOrganization ? false : true}
											/>
										</div>
									</div>
									{this.state.isNewOrganization || this.state.userCanManageOrganization ?
										<div className="btn-container">
											<div className="btn-col">
												<button
													key={'organization-save'}
													type="submit"
													className="btn-save btnPrimary btn btn-primary"
													disabled={this.state.isActive === true ? false : true}
												>
													{
														this.props.updating
														? <SpanSpinner message="Saving ..." />
														: <span>Save</span>
													}
												</button>
											</div>
											<div className="btn-col">
												<button key={'organization-cancel'} type="button" className="btnSecondary btn btn-secondary" onClick={() => {
													history.push('/dashboard');
												}}>Cancel</button>
											</div>
											<div className="btn-col">
												{this.state.isNewOrganization === false ?
													<button
														type="button"
														className="btnPrimary btn btn-primary"
														onClick={this.handleDelete}
														disabled={this.props.deleting}
													>
														{
															this.props.deleting
															? <SpanSpinner message="Deleting ..." />
															: <span>Delete</span>
														}
													</button>
													: null
												}
											</div>
										</div>
										: null
									}
								</form>
								{!this.state.userCanManageOrganization && !this.state.isNewOrganization ?
									<div className="btn-container">
										<div className="btn-col">
											<button
												key={'organization-leave'}
												type="submit"
												className="btn-save btnPrimary btn btn-primary"
												onClick={this.handleLeaving}
											>
												{
													this.props.leaving
														? <SpanSpinner message="Leaving ..." />
														: <span>Leave</span>
												}
											</button>
										</div>
									</div>
									: null
								}
							</div>
						</div>
					</div>
					{this.state.userCanManageOrganization ?
						<div className="col-lg-8 col-sm-12">
							{/* <h2 className="organization-title pt-3 pb-3">Users</h2> */}
							<div className="organization-col">
								<OrganizationUsers selectedOrganization={this.props.selectedOrganizationObj}/>
							</div>
						</div>
						: null
					}
				</div>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		organization: state.organization,
        updating: state.organization.updating,
        leaving: state.organization.leaving,
		deleting: state.organization.deleting,
		selectedOrganizationObj: state.accountDetails.selectedOrganization,
		common: state.common,
		newOrganization: state.organization.newOrganization
	};
}

export default withRouter(connect(mapStateToProps, {fetchStates, updateOrganization, deleteOrganization, selectedOrganization, leaveOrganization})(OrganizationsPage));
